module.exports = __webpack_public_path__ + "img/resource-tech-image-34.dc54ff39.jpg";